<template>
  <ToggleSection label="Screen Plate Position" :collapsed="!dv.isEditing">
    <FieldGrid
      class="form-fields"
      :fields="[
        ['plate_name', 'plate_code'],
        ['plate_type', 'plate_position'],
      ]"
      :dv="dv"
      :validation-errors="validationErrors"
    />
  </ToggleSection>
</template>

<script>
import ToggleSection from '@/components/fields/ToggleSection.vue'
import FieldGrid from '@/components/fields/FieldGrid.vue'

export default {
  name: 'SamplePlate',
  components: { ToggleSection, FieldGrid },
  props: {
    dv: { type: Object, required: true },
    validationErrors: { type: Object, default: () => ({}) },
  },
}
</script>
